import { FC } from "react";

import { OAuthRedirectDesktopPageBase } from "@/pages/oauth-redirect-desktop/oauth-redirect-desktop-page-base";

export const IntegrationsSlackCallbackDesktopHandoffPage: FC = () => {
  return (
    <OAuthRedirectDesktopPageBase
      deepLinkPath="integrations/slack/callback"
      logPrefix="IntegrationsSlackCallbackDesktopHandoffPage"
    />
  );
};
